module.exports = __webpack_public_path__ + "static/complex_scroll_2-e820918769268e61b60131edeb965f1e.png";